// src/context/ChatContext.jsx
import React, { createContext, useContext, useState } from 'react';

const ChatContext = createContext();

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

export const ChatProvider = ({ children }) => {
  const [isCustomerChatOpen, setIsCustomerChatOpen] = useState(false);

  const openCustomerChat = () => {
    console.log('Opening customer chat...');
    setIsCustomerChatOpen(true);
  };

  const closeCustomerChat = () => {
    console.log(' Closing customer chat...');
    setIsCustomerChatOpen(false);
  };

  const value = {
    isCustomerChatOpen,
    openCustomerChat,
    closeCustomerChat
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};